<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="loginUserPermission.indexOf('qr_code_generate') > -1">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">QR Code Generate</div>
                    </div>
                    <form>
                        <div class="forms-container">
                            <div class="row no-margin">
                                <div class="col-12 forms-block">
                                    <div class="common-form-field">
                                        <!-- <template v-if="vinCount < numberOfCountforGenerateQRCode">
                                            <div class="col-12 paddingleft0 plus-btn qr-code-add-btn">
                                                <button data-v-61f5e6c8="" type="button" class="btn btn-primary btn-sm" v-on:click.prevent="addLine(this)">
                                                    <i data-v-61f5e6c8="" class="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </template> -->
                                        <template v-for="(templatePage, index) in generateQRCodesArr">
                                            <div :key="'page' + index" class="col-12 paddingleft0 plus-btn qr-code-page-label pull-left">
                                                Page {{index + 1}}
                                            </div>
                                            <template v-for="(vinData, indexPage) in templatePage">
                                                <div :key="'title ' + index + 'template ' + indexPage" class="qr-vinNo-section col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="col-3 col-sm-3 col-md-3 form-title paddingleft0">
                                                        <div class="form-label">Vin No :</div>
                                                    </div>                                   
                                                    <div class="col-8 paddingleft0 vin-value">
                                                        <input type="text" maxlength="190" class="form-control" v-model="vinData.vinNo" id="last_name" placeholder="Enter Vin No" name="vinno">
                                                        <div class="help is-danger">{{vinData.vinErrorMsg}}</div>
                                                    </div>
                                                    <!-- <div class="col-1 paddingleft0 parent-icon" v-if="index > 5">
                                                        <b-button size="sm" variant="secondary" v-on:click.prevent="removeLine(index)">
                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                        </b-button>
                                                    </div> -->
                                                </div>
                                            </template>
                                            <template v-if="vinCount < numberOfCountforGenerateQRCode">
                                                <div :key="'plus-button' + index" class="col-12 paddingleft0 plus-btn qr-code-add-btn" v-if="index + 1 == generateQRCodesArr.length">
                                                    <button data-v-61f5e6c8="" type="button" class="btn btn-primary btn-sm" v-on:click.prevent="addLine(this)">
                                                        <i data-v-61f5e6c8="" class="fa fa-plus"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </template>
                                        <!-- <template v-if="vinCount < numberOfCountforGenerateQRCode">
                                            <div class="qr-vinNo-section col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                                <div class="col-3 col-sm-2 col-md-1 forms-block">
                                                    <div class="col-12 paddingleft0">
                                                        <div class="form-label">&nbsp;</div>
                                                    </div>
                                                    <div class="col-12 paddingleft0 plus-btn">
                                                        <button type="button" class="btn btn-primary btn-sm" v-on:click.prevent="addLine(this)">
                                                            <i class="fa fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template> -->
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="mr-17 pb-2 float-l">
                                        <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="generateQRCode()"><span id="createAttachment">Generate</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>   
                </div>
            </div>   
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {commonMixins} from '../../mixins/commonMixins';
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common.js';
    import moment from 'moment';
    import timezone from 'moment-timezone';
    import EventBus from "../../components/event-bus";
    Vue.component("app-footer", Footer);
    var self;
    export default {
        name: 'GenerateQRCode',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                loginUserPermission: ['qr_code_generate'],
                generateQRCodesArr: [],
                vinCount: 6,
                numberOfCountforGenerateQRCode: 15,
            }
        },
        watch: {
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.menuslug = "qr-code-generate";
            self.getRole();
            self.staticQRcodeVinData();
        },
        methods: {
            addLine: function() {
                self.vinCount = self.vinCount + 1;
                var index = self.generateQRCodesArr.length - 1;
                self.staticQRcodeVinData()
                /* if (self.generateQRCodesArr[index].part != null && self.generateQRCodesArr[index].part != '') {
                    self.generateQRCodesArr.push({
                        vinNo: '',
                        vinErrorMsg: '',
                    })
                } else {
                    self.generateQRCodesArr[index].part_error_msg = "Vin is Required.";
                } */
            },
            removeLine: function(lineId) {
                if (lineId == 0) {
                    if (!self.blockRemoval) self.generateQRCodesArr.splice(lineId, 1)
                } else {
                    self.vinCount = self.vinCount - 1;
                    self.generateQRCodesArr.splice(lineId, 1);
                }
            },
            generateQRCode: function() {
                var currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
                var format = "YYYY-MM-DD HH:mm:ss";
                var currentTimezone = moment.tz.guess();

                var convertTimezone = moment.tz(currentTime, format, currentTimezone);
                convertTimezone.utc();
                var getConvertTime = convertTimezone.format("HH:mm:ss");
                // alert(getConvertTime);return;

                var isValidated = false;
                var error = false;
                if(self.generateQRCodesArr.length > 0) {
                    for (var i = 0; i < self.generateQRCodesArr.length; i++) {
                        for (var j = 0; j < self.generateQRCodesArr[i].length; j++) {
                            if(self.generateQRCodesArr[i][j].vinNo !=  "") {
                                isValidated = true;
                                continue;
                            }
                        }
                    }
                }
                if(self.generateQRCodesArr.length > 0) {
                    for (var i = 0; i < self.generateQRCodesArr.length; i++) {
                        for (var j = 0; j < self.generateQRCodesArr[i].length; j++) {
                            self.generateQRCodesArr[i][j].vinErrorMsg = "";
                            if(self.generateQRCodesArr[i][j].vinNo != '' && self.generateQRCodesArr[i][j].vinNo.length != 6) {
                                self.generateQRCodesArr[i][j].vinErrorMsg = "Vin No only 6 characters";
                                error = true;
                            }
                        }
                    }
                }
                if(self.generateQRCodesArr.length > 0 && isValidated && !error) {
                    /* var vinData = '';
                    for (var i = 0; i < self.generateQRCodesArr.length; i++) {
                        if(!vinData.includes(self.generateQRCodesArr[i].vinNo)) {
                            vinData += (self.generateQRCodesArr[i].vinNo) + ',';
                        }
                    }
                    vinData = vinData.replace(/,\s*$/, ""); */
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                    };
                    var fields = {
                        vin_no: self.generateQRCodesArr,
                        pages: self.generateQRCodesArr.length
                    };
                    self.showLoader();
                    HTTP.post("generateqrcode", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                /* // self.showSAlert('Success', 'success');
                                localStorage.setItem("pages", self.generateQRCodesArr.length);
                                self.generateQRCodesArr = [];
                                self.staticQRcodeVinData();
                                // self.printURL = "qrcode/grid";
                                window.open("/qrcode/grid/" + response.data.content); */
                                self.generateQRCodesArr = [];
                                self.staticQRcodeVinData();
                                window.open(response.data.content);
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
                } else {
                    if(!error) {
                        self.showSAlert('Enter at least 1 Vin No', 'info');
                    }
                }
            },
            staticQRcodeVinData: function() {
                var temp = [];
                for(var i = 0; i< 6; i++) {
                    var strPrintIndex = (self.generateQRCodesArr.length + 1).toString() + (i + 1).toString();
                    temp.push({
                        vinNo: '',
                        printIndex: strPrintIndex,
                        vinErrorMsg: '',
                    })
                    /* self.generateQRCodesArr.push({
                        vinNo: '',
                        vinErrorMsg: '',
                    }) */
                }
                self.generateQRCodesArr.push(temp)
            },
        },
    };
    EventBus.$on('roleAndPermissions', function (isLogin, id, name, system_year, loginUserPermission) {
        if (typeof (self) != "undefined") {
            self.loginUserPermission = [];
            /* self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.roleName = name;
            self.system_year = system_year; */
            self.loginUserPermission = loginUserPermission;
        }
    });
</script>
<style scoped>
    .qr-vinNo-section {
        float: left;
        width: 100%;
        margin-bottom: 20px;
    }
    .parent-icon {
        float: right;
        margin-top: 8px;
    }
    .parent-icon .btn-secondary {
        color: #fff;
        background-color: #aeb1b4;
        border-color: transparent;
    }
</style>


// WEBPACK FOOTER //
// src/components/QRCode/GenerateQRCode.vue